module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/sync-button/sync-button.component.scss
// module id = ./src/app/components/sync-button/sync-button.component.scss
// module chunks = main